import { formService } from '../_services/form.service';
import { eventService } from '../_services/event.service';
import { alertActions } from './alert.actions'
import { eventConstants as constants } from '../_constants/event.constants';
import { telehealthService } from '../_services/telehealth.service';

export function getEventById(eventId) {
  return dispatch => {
    dispatch({ type: constants.EVENT_INIT_LOAD });
    dispatch({ type: constants.EVENT_GET_REQUEST });

    eventService.getEventById(eventId)
      .then(event => {
        dispatch({ type: constants.EVENT_GET_SUCCESS, event });
      })
      .catch(() => {
        dispatch(alertActions.error('Could not retrieve event details at this time. Please try again.'));
        dispatch({ type: constants.EVENT_GET_FAILURE });
      })
  }
}

export function addEventForm(eventId, data) {
  return dispatch => {
    dispatch({ type: constants.EVENT_GET_REQUEST });

    eventService.addForm(eventId, data)
      .then(event => {
        dispatch(alertActions.success('New form added.'));
        dispatch({ type: constants.EVENT_ADD_ITEM, event });
      })
      .catch(() => {
        dispatch(alertActions.error('Could not add new form at this time. Please try again.'));
        dispatch({ type: constants.EVENT_GET_FAILURE });
      })
  }
}

export function addEventTelehealth(eventId, data) {
  return dispatch => {
    dispatch({ type: constants.EVENT_GET_REQUEST });

    eventService.addTelehealth(eventId, data)
      .then(event => {
        dispatch(alertActions.success('New telehealth appointment added.'));
        dispatch({ type: constants.EVENT_ADD_ITEM, event });
      })
      .catch(() => {
        dispatch(alertActions.error('Could not add new telehealth appointment at this time. Please try again.'));
        dispatch({ type: constants.EVENT_GET_FAILURE });
      })
  }
}

export function rescheduleEvent(eventId, data) {
  return dispatch => {
    dispatch({ type: constants.EVENT_RESCHEDULING });

    eventService.rescheduleEvent(eventId, data)
      .then(event => {
        dispatch(alertActions.success('Event updated.'));
        dispatch({ type: constants.EVENT_GET_SUCCESS, event });
      })
      .catch(() => {
        dispatch(alertActions.error('Could not update event at this time. Please try again.'));
        dispatch({ type: constants.EVENT_GET_FAILURE });
      })
  }
}

export function cancelEvent(id) {
  return dispatch => {
    dispatch({ type: constants.EVENT_GET_REQUEST });

    eventService.cancelEvent(id)
      .then((event) => {
        dispatch(alertActions.success(`${event.type} Canceled!`));
        dispatch({ type: constants.EVENT_GET_SUCCESS, event });
      })
      .catch(() => {
        dispatch(alertActions.error('Could not cancel event at this time. Please try again.'));
        dispatch({ type: constants.EVENT_GET_FAILURE });
      });
  }
}

export function cancelEventItem(type, event, item) {
  return dispatch => {
    dispatch({ type: constants.EVENT_GET_REQUEST });

    if (type === 'telehealth') {
      telehealthService.cancel(item)
        .then(() => {
          dispatch(getEventById(event.id));
          dispatch(alertActions.success('Telehealth Canceled!'));
        })
        .catch(() => {
          dispatch(alertActions.error('Could not cancel at this time. Please try again.'));
          dispatch({ type: constants.EVENT_GET_FAILURE });
        });
    }
    else if (type === 'form') {
      formService.cancelForm(item)
        .then(() => {
          dispatch(getEventById(event.id));
          dispatch(alertActions.success('Form Canceled!'));
        })
        .catch(() => {
          dispatch(alertActions.error('Could not cancel at this time. Please try again.'));
          dispatch({ type: constants.EVENT_GET_FAILURE });
        });
    }
  }
}

export function rescheduleEventItem(type, event, item, data) {
  return dispatch => {
    dispatch({ type: constants.EVENT_GET_REQUEST });

    if (type === 'telehealth') {
      telehealthService.reschedule(item, data.appointmentDate, data.providerId, data.locationId, data.availableOn)
        .then(() => {
          dispatch(getEventById(event.id));
          dispatch(alertActions.success('Telehealth Rescheduled!'));

        }).catch(() => {
          dispatch(alertActions.error('Could not reschedule at this time. Please try again.'));
          dispatch({ type: constants.EVENT_GET_FAILURE });
        });
    }
    else if (type === 'form') {
      formService.rescheduleForm(item, data.appointmentDate, data.providerId, data.locationId, data.availableOn)
        .then(() => {
          dispatch(getEventById(event.id));
          dispatch(alertActions.success('Form Rescheduled!'));

        }).catch(() => {
          dispatch(alertActions.error('Could not reschedule at this time. Please try again.'));
          dispatch({ type: constants.EVENT_GET_FAILURE });
        });
    }
  }
}